export default __webpack_public_path__ + "static/media/forgot_password_5.476fe3b6.png";